import { render, staticRenderFns } from "./athlete-registration-certificate.vue?vue&type=template&id=22672098&scoped=true&"
import script from "./athlete-registration-certificate.vue?vue&type=script&lang=js&"
export * from "./athlete-registration-certificate.vue?vue&type=script&lang=js&"
import style0 from "./athlete-registration-certificate.vue?vue&type=style&index=0&id=22672098&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22672098",
  null
  
)

export default component.exports